<template>
    <div>
        <div class="character run"
             v-show="status === 'run'"
             :style="{
                backgroundImage: `url(${url.run})`,
                backgroundPositionX: `${posX.run}px`
             }"
             >
        </div>
        <div class="character stand"
             v-show="status === 'stand'"
             :style="{
                backgroundImage: `url(${url.stand})`,
                backgroundPositionX: `${posX.stand}px`
             }"
        >
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                url: {
                    run: '',
                    stand: '',
                },
                posX: {
                    run: 0,
                    stand: 0,
                },
                interval: 0,
                totalFrame: 0,
                frame: 0,
                si: null,
                status: '',
            }
        },
        watch: {
            '$userData.question': {
                handler(val) {
                }
            },
            '$userData.age': {
                handler(val) {
                    this.setCharacter('stand')
                }
            }
        },
        beforeDestroy() {
            this.$eventBus.$off('START_MOVING')
            this.$eventBus.$off('SHOW_QUESTION')
            this.$eventBus.$off('START_ENDING')
        },
        mounted() {
            this.setCharacter('stand')

            this.$eventBus.$on('START_MOVING', this.setCharacter)
            this.$eventBus.$on('SHOW_QUESTION', _ => {
                this.setCharacter('stand')
            })

            this.$eventBus.$on('START_ENDING', _ => {
                this.setCharacter('run')
            })
        },

        methods: {
            setCharacter(status) {
                if (!status) status = 'run'

                this.status = status
                let url = 'https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/'
                url += this.$userData.testAge || this.$userData.age || 20
                url += this.$userData.testGender || this.$userData.gender.toLowerCase()
                this.url.stand = url + '_stand.png'
                this.url.run = url + '_run.png'

                if (status === 'stand') {
                    this.totalFrame = 2
                    this.interval = 450 + ((this.$userData.testAge || this.$userData.age) - 20) * 9
                } else {
                    this.totalFrame = 6
                    this.interval = 150 + ((this.$userData.testAge || this.$userData.age) - 20) * 3
                }

                this.posX = {
                    stand: 0,
                    run: 0,
                }
                this.frame = 0

                this.startAnimate()
            },
            startAnimate() {
                if (this.si) {
                    clearInterval(this.si)
                    this.si = null
                }

                this.si = setInterval(_ => {
                    this.frame++
                    if (this.frame >= this.totalFrame) {
                        this.frame = 0
                    }

                    this.posX[this.status] = -132 * this.frame

                }, this.interval)

            },
        }
    }
</script>

<style>
    .character {
        position: absolute;
        width: 132px;
        height: 132px;
        bottom: 65px;
        left: 70px;

        background-size: auto 100%;
    }
</style>
